export enum BullQueueName {
  SmsGroupScheduledMessage = "scheduled-message",

  //NOTE: Per location: GET FMS data.
  FMSSyncGetDataRepeat = "fms-sync-get-data-repeat",
  // FMSSyncGetDataParents = "fms-sync-get-data-parents",
  // FMSSyncGetDataChildren = "fms-sync-get-data-children",
  FMSSyncGetDataForLocation = "fms-sync-get-data-for-location",
  //NOTE: Per location: Process/Sync FMS Data.
  // FMSSyncLocationsParents = "fms-sync-locations-parents",
  // FMSSyncLocationsChildren = "fms-sync-locations-children",
  FMSSyncLocationData = "fms-sync-location-data",

  //NOTE: per org or loc?
  SequencesRepeat = "sequences-repeat",
  SequencesOrgs = "sequences-orgs",

  ReviewsRepeat = "reviews-repeat",
  ReviewsAutoRepliesRepeat = "reviews-auto-replies-repeat",

  CampaignUsers = "campaign-users",

  RegularTasks = "regular-tasks",
}

export enum BullJobType {
  FMSSyncGetDataRepeat = "fms-sync-get-data-repeat",
  // FMSSyncGetDataParent = "fms-sync-get-data-parent",
  // FMSSyncGetDataChild = "fms-sync-get-data-child",
  FMSSyncGetDataForLocation = "fms-sync-get-data-for-location",

  // FMSSyncLocationChild = "fms-sync-location-child",
  // FMSSyncLocationsParent = "fms-sync-locations-parent",
  FMSSyncLocationData = "fms-sync-location-data",

  SequencesRepeat = "sequences-repeat",
  SequencesOrgs = "sequences-orgs",

  ReviewsRepeat = "reviews-repeat",
  ReviewsAutoRepliesRepeat = "reviews-auto-replies-repeat",

  CampaignUsers = "campaign-users",

  RegularTasks = "regular-tasks",
}

export enum BullEventType {
  Completed = "completed",
  Failed = "failed",
  Waiting = "waiting",
  Active = "active",
  Delayed = "delayed",
  Stalled = "stalled",
  Progress = "progress",
}

export type BullEmailTextType = {
  jobId: string;
  queue: string;
  data: any;
  returnValue?: any;
  durationMins?: number;
  failedReason?: string;
  error?: string;
};

// export const BullJobNotifyOnCompletionList = [BullJobType.FMSSyncGetDataRepeat, BullJobType.FMSSyncGetDataParent, BullJobType.FMSSyncLocationsParent];
export const BullJobNotifyOnCompletionList = [
  BullJobType.FMSSyncGetDataRepeat,
  BullJobType.FMSSyncGetDataForLocation,
  BullJobType.FMSSyncLocationData,
];
